<script setup>
import { onClickOutside } from '@vueuse/core'
const isOpen = ref(false)

const target = ref(null)

onClickOutside(target, () => {
  isOpen.value = false
})
</script>

<template>
  <div
    ref="target"
    class="relative w-fit">
    <button
      class="flex items-center gap-4 rounded-md px-7.5 py-4 ring-1 ring-dodger-blue hover:bg-gradient-to-t hover:from-azure-radiance hover:to-dodger-blue hover:text-white"
      @click="isOpen = !isOpen">
      <slot name="icon" />
      <slot />
    </button>

    <div
      v-if="isOpen"
      class="absolute left-0 top-full z-20 mt-2 w-fit min-w-full rounded-md bg-white py-2 text-left dark:bg-eerie-black">
      <div
        class="flex w-full flex-col gap-2 px-2 text-left"
        :class="[
          '[&>button:nth-child(even)]:bg-[#E6E9FA06] [&>button]:rounded-md [&>button]:p-3.5',
          '[&>button:nth-child(odd):hover]:bg-[#E6E9FA06]',
          '[&>button:nth-child(even):hover]:bg-transparent'
        ]">
        <slot name="buttons" />
      </div>
    </div>
  </div>
</template>
